import React, { Component } from 'react';
import ReactDOM from 'react-dom';

//TODO <li className="alli-yellow alli-yellow-bid">
class AccountLelangList extends Component{
  render(){
    return(
      <>
      <li>
        <a href="#">
        <span className="alli-left">
          <div className="lelang-sec-img">
            <img src={this.props.data.image} />
          </div>
        </span>
        <span className="alli-right">
          <div className="lelang-sec-detail">
            <div className="lelang-sec-text">{this.props.data.title}</div>
            <div className="lelang-sec-harga">{this.props.data.last_bid}</div>
            <div className="lelang-sec-det"><span><img src="http://resources.triyakom.com/mini_portal/clock.svg" /></span><span>{this.props.data.time_left}</span></div>
            <div className="lelang-sec-det"><span><img src="http://resources.triyakom.com/mini_portal/check.png" /></span><span>{this.props.data.bid_count} Tawaran</span></div>
          </div>
        </span>
        </a>
      </li>
      </>
    );
  }
}

export default AccountLelangList;
